<template>
  <footer class="bg-gray-800 text-white py-10">
    <div class="container mx-auto px-4">
      <div class="flex flex-wrap justify-between gap-8">
        <div class="max-w-md">
          <p class="font-orbitron text-lg font-semibold">A.I. Robotika Kft.</p>
          <p class="mt-2 font-roboto text-sm text-gray-300">
            Practical AI systems for technical teams: agents, computer vision, embedded ML, and automation tools.
            Founded 2004 by István Csiszár.
          </p>
        </div>
        <div class="font-roboto">
          <p class="text-sm uppercase tracking-wide text-gray-400">Get in touch</p>
          <a :href="`mailto:${email}`" class="mt-2 block text-blue-300 hover:text-blue-200 underline">{{ email }}</a>
          <router-link to="/contact" class="mt-3 inline-block rounded bg-blue-600 px-4 py-2 font-semibold
            text-white transition-colors hover:bg-blue-700">
            Start a project
          </router-link>
        </div>
      </div>
      <div class="mt-8 border-t border-gray-700 pt-4">
        <ul class="flex flex-wrap justify-center gap-4 font-roboto md:justify-start">
          <li><router-link to="/" class="hover:underline">Home</router-link></li>
          <li><router-link to="/about-us" class="hover:underline">About Us</router-link></li>
          <li><router-link to="/ai-agents" class="hover:underline">AI Agents</router-link></li>
          <li><router-link to="/labs" class="hover:underline">Labs</router-link></li>
          <li><router-link to="/contact" class="hover:underline">Contact</router-link></li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
import site from '@/seo';

export default {
  name: 'FooterComponent',
  data() {
    return { email: site.email };
  },
};
</script>
